import styled from 'styled-components';

import defaultAvatar from './assets/empty-avatar.svg';
import type { Size } from './types';

type ImageProps = {
  $src?: string;
  $size: Size;
};

export const Image = styled.div<ImageProps>(({ $src, theme: { color } }) => ({
  backgroundImage: `url("${$src || defaultAvatar}")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: $src ? 'center' : 'bottom',
  height: '100%',
  width: '100%',
  backgroundColor: !$src ? color.background.tertiary.default() : undefined,
}));
